<span (click)="isAsked ? null : askForUpdateCheck(askUpdate)" [ngClass]="{'display-flex': isAsked}">
  <mat-icon *ngIf="isAsked">check</mat-icon> {{label}}
</span>
<ng-template #askUpdate>
  <div class="dialog">
    <div class="dialog-close">
      <button (click)="dialog.closeAll(); this.askUpdateForm.reset()" mat-icon-button><mat-icon>close</mat-icon></button>
    </div>
    <div class="dialog-container">
      <div class="dialog-title">Ask For An Update</div>
      <form [formGroup]="askUpdateForm" class="dialog-form" (ngSubmit)="submit()">
        <app-input class="app-input" inputType="text"
                  [control]="name"
                  [group]="askUpdateForm"
                  [placeHolder]="info.name.placeholder"
                  [errorMessage]="info.name.error">
        </app-input>
        <app-input class="app-input" inputType="text"
                  [control]="email"
                  [group]="askUpdateForm"
                  [placeHolder]="info.email.placeholder"
                  [errorMessage]="info.email.error">
        </app-input>
        <app-captcha-input [control]="gcaptcha" type="dialog"></app-captcha-input>
        <button type="submit" class="dialog-submit-btn" mat-raised-button>Send</button>
      </form>
    </div>
  </div>
</ng-template>
